{
  "Accessibility Menu": "Menyu ya Ufikiaji",
  "Reset settings": "Weka upya mipangilio",
  "Close": "Funga",
  "Content Adjustments": "Marekebisho ya Maudhui",
  "Adjust Font Size": "Rekebisha Ukubwa wa Herufi",
  "Highlight Title": "Angazia Kichwa",
  "Highlight Links": "Angazia Viungo",
  "Readable Font": "Herufi Inayosomeka",
  "Color Adjustments": "Marekebisho ya Rangi",
  "Dark Contrast": "Tofauti ya Giza",
  "Light Contrast": "Tofauti ya Mwanga",
  "High Contrast": "Tofauti ya Juu",
  "High Saturation": "Usitishaji wa Juu",
  "Low Saturation": "Usitishaji wa Chini",
  "Monochrome": "Monokromu",
  "Contrast": "Tofauti",
  "Invert Colors": "Geuza rangi",
  "Tools": "Vifaa",
  "Reading Guide": "Mwongozo wa Kusoma",
  "Stop Animations": "Simamisha Uhuishaji",
  "Big Cursor": "Kisahihi Kikubwa",
  "Increase Font Size": "Ongeza Ukubwa wa Herufi",
  "Decrease Font Size": "Punguza Ukubwa wa Herufi",
  "Letter Spacing": "Nafasi ya Herufi",
  "Line Height": "Urefu wa Mstari",
  "Font Weight": "Uzito wa Herufi",
  "Dyslexia Font": "Herufi ya Dyslexia",
  "Language": "Lugha",
  "Open Accessibility Menu": "Fungua Menyu ya Ufikiaji",
  "Widget Settings": "Mipangilio ya wijeti",
  "Widget Position": "Nafasi ya wijeti",
  "Top Left": "Juu kushoto",
  "Top Center": "Juu katikati",
  "Top Right": "Juu kulia",
  "Center Left": "Katikati kushoto",
  "Center Right": "Katikati kulia",
  "Bottom Left": "Chini kushoto",
  "Bottom Center": "Chini katikati",
  "Bottom Right": "Chini kulia",
  "Screen Reader": "Msomaji wa skrini",
  "Voice Navigation": "Urambazaji wa sauti",
  "Custom Color": "Rangi maalum",
  "Change the site's colors": "Badilisha rangi za tovuti",
  "Backgrounds": "Mandharinyuma",
  "Headings": "Vichwa",
  "Contents": "Yaliyomo",
  "Reset colors": "Rejesha rangi",
  "Image Desaturation": "Punguza rangi ya picha",
  "Search languages": "Tafuta lugha",
  "No languages found": "Hakuna lugha zimepatikana",
  "Accessibility Profiles": "Profaili za ufikivu",
  "Motor Impaired": "Ulemavu wa mwendo",
  "Big cursor, voice navigation, and no animations.": "Kisurufa kikubwa, uelekezaji wa sauti na bila uhuishaji.",
  "Blind": "Asiyeona",
  "Screen reader helpers with higher contrast.": "Vifaa vya msomaji wa skrini vyenye utofautishaji wa juu.",
  "Color Blind": "Upofu wa rangi",
  "High contrast palette with desaturated media.": "Paleti yenye utofautishaji wa juu na rangi zilizopunguzwa.",
  "Dyslexia": "Dyslexia",
  "Friendly font, extra spacing, stronger weight.": "Fonti rahisi kusoma, nafasi zaidi na maneno mazito.",
  "Low vision": "Uoni hafifu",
  "Dark contrast and 130% magnification.": "Utofautishaji wa giza na kukuza kwa 130%.",
  "Cognitive & Learning": "Utambuzi na ujifunzaji",
  "Highlights key sections and enables voice help.": "Huwasha sehemu muhimu na kuwezesha msaada wa sauti.",
  "Seizure & Epileptic": "Kifafa na mshtuko",
  "Stops animations and desaturates imagery.": "Husimamisha uhuishaji na kupunguza rangi kwenye picha.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Mwongozo wa kusoma, viungo vilivyoangaziwa na rangi tulivu.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
